// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MeFragmentDoc } from '../../graphql/api/fragments/me.fragment.generated';
import { TranslationFragmentDoc } from '../../graphql/api/fragments/translation.fragment.generated';
import { TopBarFragmentDoc } from '../../components/layout/header/menu/api/TopBar.fragment.generated';
import { PreHeaderFragmentDoc } from '../../components/layout/header/menu/api/PreHeader.fragment.generated';
import { HeaderMenuFragmentDoc } from '../../components/layout/header/menu/api/HeaderMenu.fragment.generated';
import { SocialNetworkFragmentDoc } from '../../graphql/api/fragments/socialNetworks.fragment.generated';
import { PaymentIconFragmentDoc } from '../../graphql/api/fragments/paymentIcon.fragment.generated';
import { FooterFragmentDoc } from '../../components/layout/footer/Footer.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const EnquiryFormContentFragmentDoc = gql`
    fragment enquiryFormContent on EnquiryFormContent {
  slug
  title
  description
  buttonText
}
    `;
export const ShippingCountryCountryFragmentDoc = gql`
    fragment shippingCountryCountry on Country {
  isoCode
  currency
}
    `;
export const ShippingCountryFragmentDoc = gql`
    fragment shippingCountry on ShippingCountries {
  countries {
    ...shippingCountryCountry
  }
}
    ${ShippingCountryCountryFragmentDoc}`;
export const InitDocument = gql`
    query init($locale: Locale!, $isConsultant: Boolean!, $fetchCountrySuggest: Boolean!) {
  me {
    ...me
  }
  workingHours(locale: $locale) {
    weekDays
    opening
    closing
  }
  shippingCountries {
    ...shippingCountry
  }
  countrySuggest @include(if: $fetchCountrySuggest) {
    isoCode
  }
  language(locale: $locale) {
    locale
    translations {
      ...translation
    }
  }
  topBar(locale: $locale) {
    ...topBar
  }
  preHeader(locale: $locale) {
    ...preHeader
  }
  mainMenu(locale: $locale) {
    ...headerMenu
  }
  socialNetworks(locale: $locale) {
    ...socialNetwork
  }
  paymentIcons(locale: $locale) {
    ...paymentIcon
  }
  footer(locale: $locale) {
    ...footer
  }
  enquiryFormContents(locale: $locale) {
    ...enquiryFormContent
  }
}
    ${MeFragmentDoc}
${ShippingCountryFragmentDoc}
${TranslationFragmentDoc}
${TopBarFragmentDoc}
${PreHeaderFragmentDoc}
${HeaderMenuFragmentDoc}
${SocialNetworkFragmentDoc}
${PaymentIconFragmentDoc}
${FooterFragmentDoc}
${EnquiryFormContentFragmentDoc}`;

export function useInitQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.InitQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.InitQuery, SchemaTypes.InitQueryVariables | undefined>({ query: InitDocument, variables: undefined, ...options });
};